export default {
    home: 'Home',
    fundingPrograms: 'Förderprogramme',
    notifications: 'Benachrichtigungen',
    myProfile: 'Mein Profil',
    myOrganisation: 'Meine Organisation',
    myUsers: 'Nutzer',
    login: 'Login',
    logout: 'Logout',
    service: 'Intern',
    dashboard: 'Dashboard',
    processes: 'Vorgänge',
    groupedByEvents: 'Gruppiert nach Veranstaltungen',
    groupedByFundingProgram: 'Gruppiert nach Förderprogrammen',
    payment: 'Zahlungsjournal',
    reporting: 'Auswertungen',
    info: 'Info',
    statistics: 'Statistik',
    statisticProcesses: 'Statistikmeldungen',
    statisticProcessTransfers: 'Übermittlungen Statistikmeldungen',
    statisticForms: 'Statistikformulare',
    statisticSurveys: 'Statistikerhebungen',
    users: 'Nutzer',
    organisations: 'Organisationen',
    basicData: 'Stammdaten',
    forms: 'Formulare',
    categories: 'Kategorien',
    statuses: 'Status',
    roles: 'Rollen',
    years: 'Jahre',
    mailTemplates: 'E-Mailvorlagen',
    mails: 'E-Mails',
    ags: 'AGS',
    information: 'Informationen',
    settings: 'Einstellungen',
    jugendzaehlt: 'Jugend Zählt',
    regions: 'Kirchenbezirke',
    parishes: 'Kirchengemeinden',
    loginProviders: 'Login Methoden',
    paymentRuns: 'Zahlungsläufe',

    secret: 'Geheimnis',
    nothingToSeeHere: 'Hier gibt es nichts zu sehen 🙈',
    escapeRoom: '//farbcode Dungeon Escape! 🏰',
    dungeon: 'Dungeon',
    overview: 'Input-Übersicht'
}
